module.exports = __webpack_public_path__ + "img/GAME_MAHJONGSOLITAIRE.981627c8.png";